import type { ReactNode } from 'react';
import { FormProvider as Form } from 'react-hook-form';
import type { UseFormReturn } from 'react-hook-form';

interface FormProviderProps<TFormValues extends Record<string, unknown>> {
  children: ReactNode;
  methods: UseFormReturn<TFormValues>;
  onSubmit?: (_e?: React.BaseSyntheticEvent) => void;
}

export function FormProvider<TFormValues extends Record<string, unknown>>({
  children,
  onSubmit = (): void => { },
  methods
}: FormProviderProps<TFormValues>): JSX.Element {
  return (
    <Form {...methods}>
      <form onSubmit={onSubmit}>{children}</form>
    </Form>
  );
}
